import type { TPlanDraftPayload, TPlanDraftSession } from './trainingPlanDraftInterface'

// Slots and answers are timestamps; the days stay 'YYYY-MM-DD' strings.

export const afterReceivingSession = (session: any): TPlanDraftSession => ({
  ...session,
  requestedAt: session.requestedAt ? new Date(session.requestedAt) : null,
  slots: (session.slots || []).map((slot: any) => ({ ...slot, start: new Date(slot.start), end: new Date(slot.end) })),
  trainerResponses: (session.trainerResponses || []).map((response: any) => ({
    ...response,
    respondedAt: response.respondedAt ? new Date(response.respondedAt) : null,
  })),
  myResponse: session.myResponse
    ? { ...session.myResponse, respondedAt: session.myResponse.respondedAt ? new Date(session.myResponse.respondedAt) : null }
    : session.myResponse,
})

export const afterReceivingPayload = (data: any): TPlanDraftPayload => ({
  ...data,
  draft: data?.draft ? { ...data.draft, sentAt: data.draft.sentAt ? new Date(data.draft.sentAt) : null } : null,
  scenarios: (data?.scenarios || []).map((scenario: any) => ({ ...scenario, sentAt: scenario.sentAt ? new Date(scenario.sentAt) : null })),
  sessions: (data?.sessions || []).map(afterReceivingSession),
  sourceCounts: data?.sourceCounts || [],
})
